import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { GET_ROLES } from 'const';
import { Role } from 'types';

export const fetchRoles = async (
  data: any,
  config?: AxiosRequestConfig,
): Promise<AxiosResponse<Role[]>> => {
  const result = await axios.get<{ result: Role[] }>(GET_ROLES, config);

  // Construyes un AxiosResponse<Role[]> compatible:
  return {
    ...result,
    data: result.data.result, // Ajustas el tipo para que sea Role[]
  };
};
